import React from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import TradeCard from './TradeCard';

// Individual portfolio item component that only re-renders when relevant data changes
const PortfolioItem = ({ trade, priceChangeConfig, closeFromPortfolio }) => {
  // Only select quote data for this specific instrument
  const quoteData = useSelector(
    (state) => state.trade.quotesData[trade?.script?.instrument_token]
  );
  
  // Merge the latest price data with the trade data
  const updatedTrade = {
    ...trade,
    script: { ...trade.script, ...quoteData },
    type: 'OPEN',
  };
  
  return (
    <Grid item xs={12}>
      <TradeCard
        trade={updatedTrade}
        closeFromPortfolio={closeFromPortfolio}
        priceChangeConfig={priceChangeConfig}
        allowQuantityModification
      />
    </Grid>
  );
};

// Memoize the component to prevent re-renders when props don't change
export default React.memo(PortfolioItem, 
  (prevProps, nextProps) => {
    // Re-render if trade ID changes
    if (prevProps.trade?._id !== nextProps.trade?._id) return false;
    
    // Re-render if priceChangeConfig changes
    if (prevProps.priceChangeConfig !== nextProps.priceChangeConfig) return false;
    
    // Otherwise don't re-render
    return true;
  }
);
